import React from "react";
import "./Installers.css";
import { FaFacebook, FaInstagram } from "react-icons/fa";
const Installers = () => {
  return (
    <>
      <div className="installers-img">
        <div className="installers-head ">
          <div className="installers-overlay">
            <h2 className="heading">OUR INSTALLERS</h2>
            <p className="installers-para  " style={{ textAlign: "justify" }}>
              As a trusted Armure dealer, we prioritize your satisfaction by
              delivering excellence in every application of our Paint Protection
              Film. Our certified installers are well-versed in the intricacies
              of PPF installation, ensuring a seamless and virtually
              undetectable layer of protection for your vehicle's paintwork.
              Armure's PPF not only shields against external elements but also
              preserves the original aesthetics of your car, maintaining its
              glossy finish for years to come.Partnering with us means gaining
              access to top-tier Armure products, backed by our commitment to
              customer satisfaction and professional service. Discover the
              ultimate in automotive protection with Armure's Paint Protection
              Film where innovation meets preservation. Visit our certified
              installer team today to experience the future of car care.
            </p>
          </div>
        </div>
      </div>
      <div className="container  installers">
        <div className="row justify-content-center ">
          <div className="col-lg-12 ">
            <div className="list-group row-gap-5 text-start mt-5">
              <div
                className="list-group-item border-0"
                style={{ color: "#febb3e", backgroundColor: "#0e1c39" }}
              >
                <div className="row fw-bold">
                  <div className="col-2 ">Name</div>
                  <div className="col-3 ">City</div>
                  <div className="col-3">Address</div>
                  <div className="col-2">Phone</div>
                  <div className="col-2">Links</div>
                </div>
              </div>

              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Detailing Hub </div>
                  <div className="col-3  ">Faisalabad</div>
                  <div className="col-3">
                    Commercial Market, F-Block, Eden Valley, Faisalabad.
                  </div>
                  <div className="col-2">0311-2200767</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/detailinghub797?mibextid=LQQJ4d"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/detailinghub.fsd?igsh=YjNxaDV4Nmo5ZXdo&utm_source=qr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row text-start">
                  <div className="col-2">Usmanz Autoplex</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                    Street-12, Golra NPF, E-11/4 Islamabad.
                  </div>
                  <div className="col-2">0333-6831109</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/UZautoplex"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/usmanzautoplex/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
                <div className="list-group-item bg-transparent text-white border-0">
                <div className="row text-start">
                  <div className="col-2">Prestige Detailing
Islamabad</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                   Block B Multi Gardens B-17, Islamabad.
                  </div>
                  <div className="col-2">0313-1510060</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/profile.php?id=61582911641713"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/prestige_detailing_islamabad/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Shift Car Studio</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                    SB Marketing Road, G-9 Markaz, G-9 Islamabad.
                  </div>
                  <div className="col-2">0311-1069873</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="http://Facebook.com/shiftcarstudio"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="http://Instagram.com/shiftcarstudio"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
               <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Perfection Auto Care</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                   Plot No 215, I-10/3 Main Service Road East Islamabad.
                  </div>
                  <div className="col-2">0322-5056398</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/PerfectionAutoCare85"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/perfection.auto.care/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

               <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Hyundai Blue Islamabad</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                   782/73 Golra Rd, H-13, Islamabad.
                  </div>
                  <div className="col-2">051-8911555</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/p/Hyundai-Blue-Islamabad-61577944370126/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/hyundaiblueisb5/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              
               <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Auto Aesthetics</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                   782/73 Golra Rd, H-13, Islamabad.
                  </div>
                  <div className="col-2">0329-5195600</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/p/Auto-Aesthetics-61568531692522/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/autoaestheticslab/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Metro-<br />polis Car Care (MCC)</div>
                  <div className="col-3 ">Islamabad</div>
                  <div className="col-3">
                   Industrial Area, Potohar Road, I-9, Islamabad.
                  </div>
                  <div className="col-2">0335-5828168</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="/"
                      target=""
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="/"
                      target=""
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Auto-<br />motive Technologies PVT LTD.</div>
                  <div className="col-3 ">Karachi</div>
                  <div className="col-3">
                   Haval-Yazdani-ATPL, Sector-5 Korangi, Karachi.
                  </div>
                  <div className="col-2">0330-2009902</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="/"
                      target=""
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="/"
                      target=""
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Restor FX Karachi</div>
                  <div className="col-3 ">Karachi</div>
                  <div className="col-3">
                    Mall Shoping Centre, 7th Commercial lane, Zamzama DHA-5
                    Karachi.
                  </div>
                  <div className="col-2">0310-1111889</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/RFXCDHAKHI"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/restorfx.karachi_dha/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">GWM Creek</div>
                  <div className="col-3 ">Karachi</div>
                  <div className="col-3">
                    Deh Dih Tapo, 245/1 Ibrahim Hyderi Rd, Korangi Creek, Karachi.
                  </div>
                  <div className="col-2">0320-8104820</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/gwm.creek/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/gwm.creek?igsh=NTM3ZGpxZHB3ZHIy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

               <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">LifeStyle Performance</div>
                  <div className="col-3 ">Karachi</div>
                  <div className="col-3">
                    Deh Dih Tapo, 245/1 Ibrahim Hyderi Rd, Korangi Creek, Karachi.
                  </div>
                  <div className="col-2">0303-3009900</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/profile.php?id=61563487897455"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/lifestyleperformancepk?igsh=MWEwaDN4aDNiZGdwMg=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Hyundai Shahrah e Faisal</div>
                  <div className="col-3 ">Karachi</div>
                  <div className="col-3">
                    159 Shahrah e Faisal Road, Bangalore Town, Darwaish Colony
                    Karachi.
                  </div>
                  <div className="col-2">0304-2226765</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/Hyundai.shahrahefaisal"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/hyundai.shahrahefaisal/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Maxshine Auto Care</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                    E-38, Tipu Sultan Lane, Street-6 Cavalary Ground, Lahore
                    Cantt.
                  </div>
                  <div className="col-2">0322-4355842</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/Maxshineautocare?mibextid=ZbWKwL"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/maxshineautocare/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Haval Club</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                    Haval Club Service 12-Q, Gulberg-2, Lahore.
                    
                  </div>
                  <div className="col-2">0336-0733332</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://web.facebook.com/Havalclubpk"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/havalclubpk/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
               <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Hyundai Premium</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                    17 KM Multan Rd, opposite ShahPur Kanjra Cattle Market Gate, Multan Rd, Kot Gujra, Lahore.
                    
                  </div>
                  <div className="col-2">0345-4478080</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/hyundaipremiummotors"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/hyundai_premium/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Platinum Motor Works</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                    Service Lane, Ring Road, Behind Karak Khel, State Life
                    Interchange, DHA Lahore.
                  </div>
                  <div className="col-2">0321-4973232</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/Platinum.CarStudio"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/platinum.carstudio/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Toyota Walton Motors</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                    Main Walton Road, Lahore.
                  </div>
                  <div className="col-2">0333-4505365</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/ToyotaWaltonMotors?mibextid=LQQJ4d"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/toyotawalton/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Upgrade Auto Detailing</div>
                  <div className="col-3 ">Lahore</div>
                  <div className="col-3">
                  Opp. Lahoriya Restaurant, Main Sutlej Ave. Plot no 99 C 2 Punjab Govt Employee Society Phase-1, Lahore.
                  </div>
                  <div className="col-2">0339-0001744</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/Upgradeautodetailing"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/upgradeautodetailing?igsh=MXRmYm42enE5dDlpNg=="
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Auto Aeon Detailing & Car Wash</div>
                  <div className="col-3 ">Multan</div>
                  <div className="col-3">
                  9 Star Arcade Shop no. 20 Bosen Road opposite DHA Gate Multan.
                  </div>
                  <div className="col-2">0300-8633772</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/autoaeon"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/explore/locations/1610148312598415/auto-aeon-detailing-car-care/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Toyota Multan Motors</div>
                  <div className="col-3 ">Multan</div>
                  <div className="col-3">
                  Bosan Road, Multan.
                  </div>
                  <div className="col-2">0300-0605370</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/ToyotaMultanMotors"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/toyotamultan/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Gulistan Car Studio</div>
                  <div className="col-3 ">Multan</div>
                  <div className="col-3">
                    House-3, Gulistan Colony, Old Bahawalpur Road Multan.
                  </div>
                  <div className="col-2">0300-6344556</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/gulistancarstudio"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/multancarstudio/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Ali Auto Detailing</div>
                  <div className="col-3 ">Peshawar</div>
                  <div className="col-3">Ali CNG Byco Filling Station, Bara Gate, Bara Road, Peshawar.</div>
                  <div className="col-2">0333-9608536</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/Alicngbyco"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/explore/locations/1629937780640127/ali-auto-detailing/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Gloss Treatment Auto</div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
          22/A, C-Block, Satellite Town, Rawalpindi.
                  </div>
                  <div className="col-2">0333-5112962</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/GlossTreatment?mibextid=ZbWKwL"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/explore/locations/1878844975741906/gloss-treatment-auto/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Restor FX Center Pakistan</div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
                    Main Airport Road, Near Bank Alfalah Fazal Town, Service
                    Road Rawalpindi.
                  </div>
                  <div className="col-2">0345-8500438</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/RFXCPK?mibextid=LQQJ4d"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://instagram.com/restorfxcenterpk?igshid=MzMyNGUyNmU2YQ%3D%3D&utm_source=qr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Mobil AutoSpa </div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
                    Peshawar Road, Naseerabad, Rawalpindi.
                  </div>
                  <div className="col-2">0332-3060166</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/autospapk"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/explore/locations/193754334423765/mobil-autospa/nearby/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Top Care <br />
                  Branch-l</div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
                  Plot No 8#, Defence road near Askari 14 gate no 2, Rawalpindi.
                  </div>
                  <div className="col-2">0334-0590954</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/TopCare1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/topcare_pakistan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Top Care <br />
                    Branch-ll </div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
                  Main GT Road, Opposite Al-Shifa Eye Hospital, Rawalpindi.
                  </div>
                  <div className="col-2">0334-0590954</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/TopCare1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/topcare_pakistan"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Carbo-<br />graphics</div>
                  <div className="col-3 ">Rawalpindi</div>
                  <div className="col-3">
                  Opposite BYCO petrol pump, Adj Gulrez colony gate no. 3 near high court road, Rawalpindi.
                  </div>
                  <div className="col-2">0321-9255779</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/carbographics"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/carbographics"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>
              <div className="list-group-item bg-transparent text-white border-0">
                <div className="row ">
                  <div className="col-2">Auto Tech</div>
                  <div className="col-3 ">Sargodha</div>
                  <div className="col-3">Railway Road Sargodha.</div>
                  <div className="col-2">0300-8600960</div>
                  <div className="col-2 social-media-pages">
                    <a
                      className="text-warning"
                      href="https://www.facebook.com/profile.php?id=100063797560559"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook className="social-icon" />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      className="text-warning"
                      href="https://www.instagram.com/explore/locations/280413295926081/relway-raod-sargodha/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram className="social-icon" />
                    </a>
                  </div>
                </div>
              </div>

              <div
                className="list-group-item border-0"
                style={{ color: "#febb3e", backgroundColor: "#121f3f" }}
              >
                <div className="row ">
                  <div className="col-3"></div>
                  <div className="col-4"></div>
                  <div className="col-2"></div>
                  <div className="col-3"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Installers;
